import Service from './Service';

class VersaoSistemaService extends Service {
  async consultar () {
    return await this.getVersaoSistemaApi().consultar() || [];
  }
}

export default VersaoSistemaService;
